import React from 'react';
import { getProcurementStatusEmoji } from '../../utils/productOpenProcurement';

/**
 * Status label with procurement-stage emoji for open quotes/orders tables.
 *
 * @param {Object} props
 * @param {string|null|undefined} props.status - Human-readable status from API
 * @param {string} [props.className]
 * @param {boolean} [props.muted] - Muted text (e.g. line reception sub-label)
 */
const OpenProcurementStatusCell = ({ status, className = '', muted = false }) => {
  if (!status) {
    return <>—</>;
  }

  const emoji = getProcurementStatusEmoji(status);
  const textClass = muted ? `text-muted small ${className}`.trim() : className;

  return (
    <span className={textClass || undefined}>
      {emoji && (
        <span className="open-procurement-status__emoji me-1" aria-hidden="true">
          {emoji}
        </span>
      )}
      {status}
    </span>
  );
};

export default OpenProcurementStatusCell;
